"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDualListboxComponents = exports.defaultSelectComponents = void 0;
var Panel_1 = require("../../Panel");
var Listbox_1 = require("../Listbox");
var AddControl_1 = require("./AddControl");
var AddInvitationControl_1 = require("./AddInvitationControl");
var DropDownContainer_1 = require("./DropDownContainer");
var SelectContainer_1 = require("./SelectContainer");
var SelectControl_1 = require("./SelectControl");
var SelectOption_1 = require("./SelectOption");
var SelectOptionContainer_1 = require("./SelectOptionContainer");
var SelectSearchInput_1 = require("./SelectSearchInput");
var SelectValue_1 = require("./SelectValue");
var SelectValueContainer_1 = require("./SelectValueContainer");
exports.defaultSelectComponents = {
    OuterMostContainer: SelectContainer_1.SelectContainer,
    CollapsedControlContainer: SelectControl_1.SelectControl,
    DropDownContainer: DropDownContainer_1.DropDownContainer,
    Option: SelectOption_1.SelectOption,
    OptionContainer: SelectOptionContainer_1.SelectOptionContainer,
    OptionsPanel: Panel_1.Panel,
    SearchInput: SelectSearchInput_1.SelectSearchInput,
    Value: SelectValue_1.SelectValue,
    ValueContainer: SelectValueContainer_1.SelectValueContainer,
    AddInvitationControl: AddInvitationControl_1.AddInvitationControl,
    AddControl: AddControl_1.SingleValueAddControl,
};
exports.defaultDualListboxComponents = __assign(__assign({}, exports.defaultSelectComponents), { Listbox: Listbox_1.Listbox });
//# sourceMappingURL=SelectComponents.js.map